import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";

import SimpleBar from 'simplebar-react';

import { Link, useHistory } from 'react-router-dom';
import { DckLogo } from '../../components/DCKeeper/ui/DckLogo';
import BreadCrumb from '../../components/Common/BreadCrumb';

// DC Keeper:會員/鈴鐺下拉資料(DCK-00 layout — 對齊 Figma 使用者下拉・訊息通知)
import { useSessionStore } from "../../stores/sessionStore";
import { useUiStore } from "../../stores/uiStore";
import { useRbac, NoticeItem } from "../../components/DCKeeper";
import { useResourceList, useResourceMutations } from "../../query/useResource";
import { notificationsApi, notifyMuteRulesApi } from "../../helpers/dck_helper";
import { isNotificationMuted } from "../../helpers/notifyMeta";
import ChangePasswordDialog from "./ChangePasswordDialog";


import { connect } from "react-redux";

// Redux Store
import {
    showRightSidebarAction,
    toggleLeftmenu,
    changeSidebarType,
} from "../../store/actions";

const Header = ({ breadCrumbItems }) => {
    //Notification Dropdown
    const [notification, setNotification] = useState(false);
    const toggleNotification = () => {
        setNotification(!notification);
    };

    //Profile Dropdown
    const [profile, setProfile] = useState(false);
    const [changePw, setChangePw] = useState(false);
    const toggleProfile = () => {
        setProfile(!profile);
    };

    // —— DC Keeper:會員/通知資料(DCK-00 layout) ——
    const history = useHistory();
    const sessionUser = useSessionStore((s) => s.user);
    const sessionLogout = useSessionStore((s) => s.logout);
    // 會員選單的角色列照設計稿(2128:21413)顯示角色代碼(如 Gatekeeper),不是中文說明
    const { role } = useRbac();
    const pageTitle = useUiStore((s) => s.pageTitle);
    // 返回箭頭與標題同群組(Figma v2 2128:23479);沒有頁面發佈 onBack 時是 null
    const pageBack = useUiStore((s) => s.pageBack);
    const notifyQ = useResourceList(notificationsApi, "notifications", { pageSize: 100 });
    const { update: updateNotify } = useResourceMutations(notificationsApi, "notifications");
    const muteRulesQ = useResourceList(notifyMuteRulesApi, "notify-mute-rules", { pageSize: 100 });
    const muteRules = muteRulesQ.data?.data ?? [];
    const notifyItems = (notifyQ.data?.data ?? []).slice(0, 6);
    const unreadCount = (notifyQ.data?.data ?? []).filter((n) => !n.read && !isNotificationMuted(n, muteRules)).length;
    const markAllRead = async () => {
        const unread = (notifyQ.data?.data ?? []).filter((n) => !n.read && !isNotificationMuted(n, muteRules));
        await Promise.all(unread.map((n) => updateNotify.mutateAsync({ id: n.id, data: { read: true } })));
    };
    const doLogout = () => {
        sessionLogout();
        history.push("/auth-login");
    };

    //scroll navbar
    const [navClass, setnavClass] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
        return () => window.removeEventListener("scroll", scrollNavigation, true);
    }, []);

    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setnavClass("sticky");
        } else {
            setnavClass("");
        }
    }

    function tToggle() {
        var body = document.body;
        if (window.screen.width <= 998) {
            body.classList.toggle("sidebar-enable");
        } else {
            body.classList.toggle("sidebar-enable");
            body.setAttribute("data-sidebar-size","lg");
        }
    }

    return (
        <React.Fragment>
            <header id="page-topbar" className={"isvertical-topbar " + navClass}>
                <div className="navbar-header">
                    <div className="d-flex">

                        {/* Figma side menu(15:848)左上字標;客戶提供的 SVG 原件(單色 currentColor)*/}
                        <div className="navbar-brand-box">
                            <Link to="/" className="logo logo-dark">
                                <span className="logo-sm"><DckLogo height={16} variant="mark" /></span>
                                <span className="logo-lg"><DckLogo height={25.27} /></span>
                            </Link>

                            <Link to="/" className="logo logo-light">
                                <span className="logo-sm"><DckLogo height={16} variant="mark" /></span>
                                <span className="logo-lg"><DckLogo height={25.27} /></span>
                            </Link>
                        </div>

                        <button type="button" className="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn topnav-hamburger" onClick={() => tToggle() }>
                            <div className="hamburger-icon open">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>

                        {/* Figma「top > con」左側:返回箭頭 24px + gap 10 + 頁面標題 Inter Bold 20px。
                            兩者都由 usePageTitle(title, onBack) 發佈到 uiStore
                            (內容區不再另有一層頁首,也不再自己畫一列返回鍵)。 */}
                        <BreadCrumb
                            breadCrumbItems={{ title: pageTitle || breadCrumbItems?.title }}
                            onBack={pageBack}
                        />
                    </div>
                    {/* Figma「top > con > Frame 1」:鈴鐺 24px + 頭像 36px,間距 14px */}
                    <div className="d-flex align-items-center" style={{ gap: 14 }}>
                        <Dropdown className="d-inline-block" isOpen={notification} toggle={toggleNotification}>
                            <DropdownToggle
                                tag="button"
                                type="button" className="btn header-item noti-icon" id="page-header-notifications-dropdown"
                                aria-label="通知">
                                {/* 模板 VerticalLayout Header:bx-bell + noti-dot 徽章 */}
                                <i className="bx bx-bell" />
                                {unreadCount > 0 ? (
                                    <span className="noti-dot bg-danger rounded-pill">{unreadCount}</span>
                                ) : null}
                            </DropdownToggle>
                            {/* Figma「下拉選單」318×359 = 10 + 標題列 39 + 清單 265 + 底部 35 + 10 */}
                            <DropdownMenu className="dropdown-menu-end dck-notify-menu">
                                <div className="dck-notify-menu-head">
                                    <span className="title">訊息通知</span>
                                    <Link to="#" className="dck-notify-link"
                                        onClick={(e) => { e.preventDefault(); markAllRead(); }}>全部已讀</Link>
                                </div>
                                {/* 設計稿清單區 265 含底部那條 1px 線;線改掛在底部區塊 → 捲動區取 264 */}
                                <SimpleBar data-simplebar style={{ maxHeight: 264 }}>
                                    <div className="dck-notify-menu-list">
                                        {notifyItems.length === 0 ? (
                                            <div className="text-center text-muted py-4">目前沒有通知</div>
                                        ) : notifyItems.map((n) => (
                                            <Link to="/dck/notify" className="text-reset d-block" key={n.id}>
                                                <NoticeItem
                                                    source={n.source}
                                                    message={n.message}
                                                    docNo={n.docNo}
                                                    time={n.createdAt}
                                                    unread={!n.read && !isNotificationMuted(n, muteRules)}
                                                />
                                            </Link>
                                        ))}
                                    </div>
                                </SimpleBar>
                                <div className="dck-notify-menu-bottom">
                                    <Link to="/dck/notify" className="dck-notify-link">看更多訊息</Link>
                                </div>
                            </DropdownMenu>
                        </Dropdown>

                        <Dropdown className="d-inline-block" isOpen={profile} toggle={toggleProfile}>
                            <DropdownToggle tag="a" type="button"
                                className="btn header-item user text-start d-flex align-items-center"
                                id="page-header-user-dropdown"
                                to="#"
                            >
                                {/* Figma v2「img」(2128:23479):36px 圓形、底色與框線同為 Primary/Color #4975DA、
                                    字 20px Bold 白。設計稿放的是照片,mock 使用者無照片 → 退回姓氏字元。 */}
                                <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-bold"
                                    style={{ width: 36, height: 36, fontSize: 20, border: "1px solid #4975da" }}>
                                    {sessionUser && sessionUser.name ? sessionUser.name.charAt(0) : "?"}
                                </span>
                            </DropdownToggle>
                            {/* Figma「使用者下拉選單」:200 寬、上下內距 10、Shadow/Large。
                                設計稿的「個人資料」項為 display:none → 只留重設密碼與登出。 */}
                            <DropdownMenu className="dropdown-menu-end border-0 dck-user-menu">
                                <div style={{ padding: 10, borderBottom: "1px solid #abb5be" }}>
                                    <div style={{ fontSize: 16, lineHeight: "19px", fontWeight: 700, color: "#212529" }}>
                                        {sessionUser ? sessionUser.name : "未登入"}
                                    </div>
                                    <div style={{ marginTop: 5, fontSize: 11, lineHeight: "13px", color: "#54595e" }}>{role}</div>
                                </div>
                                <div style={{ padding: 10 }}>
                                    {/* 人已登入,改密碼要驗舊密碼(Figma 24:9203),不是走忘記密碼寄連結 */}
                                    <DropdownItem onClick={() => setChangePw(true)} className="dck-user-menu-item">
                                        <i className="bx bx-key" style={{ fontSize: 16 }} />
                                        <span>重設密碼</span>
                                    </DropdownItem>
                                </div>
                                <div style={{ padding: "10px 10px 0" }}>
                                    <DropdownItem onClick={doLogout} className="dck-user-menu-item">
                                        <i className="bx bx-log-out" style={{ fontSize: 16 }} />
                                        <span>登出</span>
                                    </DropdownItem>
                                </div>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </header>
            {/* 首登尚未改初始密碼 → 關不掉的強制彈窗;否則才是會員選單那顆自願改的 */}
            {sessionUser && sessionUser.mustChangePassword ? (
                <ChangePasswordDialog isOpen force />
            ) : (
                <ChangePasswordDialog isOpen={changePw} toggle={() => setChangePw(false)} />
            )}
        </React.Fragment>
    );
};

Header.propTypes = {
    changeSidebarType: PropTypes.func,
    leftMenu: PropTypes.any,
    leftSideBarType: PropTypes.any,
    showRightSidebar: PropTypes.any,
    showRightSidebarAction: PropTypes.func,
    t: PropTypes.any,
    toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
    const {
        layoutType,
        showRightSidebar,
        leftMenu,
        leftSideBarType,
    } = state.Layout;
    return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
    showRightSidebarAction,
    toggleLeftmenu,
    changeSidebarType,
})((Header));
